const formatToDH = (number) => {
    const formattedNumber = new Intl.NumberFormat('fr-MA').format(number);
    return `${formattedNumber} DH`;}

export default formatToDH